import * as i from "react";
import { forwardRef as p, useContext as O } from "react";
import S from "./index16.mjs";
import { getRegisteredStyles as C, registerStyles as P, insertStyles as T } from "./index17.mjs";
import { serializeStyles as E } from "./index18.mjs";
import { useInsertionEffectAlwaysWithSyncFallback as w } from "./index19.mjs";
var N = {}.hasOwnProperty, d = /* @__PURE__ */ i.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ S({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (d.displayName = "EmotionCacheContext");
d.Provider;
var y = function(t) {
  return /* @__PURE__ */ p(function(e, r) {
    var a = O(d);
    return t(e, a, r);
  });
}, _ = /* @__PURE__ */ i.createContext({});
process.env.NODE_ENV !== "production" && (_.displayName = "EmotionThemeContext");
var g = function(t) {
  var e = t.split(".");
  return e[e.length - 1];
}, x = function(t) {
  var e = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(t);
  if (e || (e = /^([A-Za-z0-9$.]+)@/.exec(t), e)) return g(e[1]);
}, L = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), z = function(t) {
  return t.replace(/\$/g, "-");
}, D = function(t) {
  if (t)
    for (var e = t.split(`
`), r = 0; r < e.length; r++) {
      var a = x(e[r]);
      if (a) {
        if (L.has(a)) break;
        if (/^[A-Z]/.test(a)) return z(a);
      }
    }
}, m = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", u = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", $ = function(t, e) {
  if (process.env.NODE_ENV !== "production" && typeof e.css == "string" && // check if there is a css declaration
  e.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + e.css + "`");
  var r = {};
  for (var a in e)
    N.call(e, a) && (r[a] = e[a]);
  if (r[m] = t, process.env.NODE_ENV !== "production" && e.css && (typeof e.css != "object" || typeof e.css.name != "string" || e.css.name.indexOf("-") === -1)) {
    var o = D(new Error().stack);
    o && (r[u] = o);
  }
  return r;
}, F = function(t) {
  var e = t.cache, r = t.serialized, a = t.isStringTag;
  return P(e, r, a), w(function() {
    return T(e, r, a);
  }), null;
}, h = /* @__PURE__ */ y(function(n, t, e) {
  var r = n.css;
  typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
  var a = n[m], o = [r], f = "";
  typeof n.className == "string" ? f = C(t.registered, o, n.className) : n.className != null && (f = n.className + " ");
  var c = E(o, void 0, i.useContext(_));
  if (process.env.NODE_ENV !== "production" && c.name.indexOf("-") === -1) {
    var v = n[u];
    v && (c = E([c, "label:" + v + ";"]));
  }
  f += t.key + "-" + c.name;
  var l = {};
  for (var s in n)
    N.call(n, s) && s !== "css" && s !== m && (process.env.NODE_ENV === "production" || s !== u) && (l[s] = n[s]);
  return l.ref = e, l.className = f, /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement(F, {
    cache: t,
    serialized: c,
    isStringTag: typeof a == "string"
  }), /* @__PURE__ */ i.createElement(a, l));
});
process.env.NODE_ENV !== "production" && (h.displayName = "EmotionCssPropInternal");
var M = h;
export {
  M as E,
  _ as T,
  $ as c,
  N as h,
  y as w
};
